import React from 'react';

const EducationalRequirements = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="bg-white shadow-md rounded-lg p-6 mb-6">
        {/* Introductory Paragraph */}
        <p className="mb-4">
          Our <a href="#programs" className="text-blue-500 underline">programs</a> are uniquely designed around your needs as a business professional. For information on courses offered and program requirements, please visit the web page for each of our programs. If you need additional information, please do not hesitate to contact us. We are here to serve you and to help you in the pursuit of your dreams.
        </p>

        {/* Course Numbering System Section */}
        <h2 className="text-2xl font-bold mb-4">Course Numbering System</h2>
        <p className="mb-4">
          All undergraduate and graduate courses are numbered using a six-character identifier. Bachelor's level courses begin with BBA followed by a three-digit numeric value from 100-499. Courses beginning with 100 represent first-year undergraduate courses, 200 represents the second year, 300 represents the third year, and 400 represents the fourth-year undergraduate course. Master's level courses begin with MBA followed by a three-digit numeric value from 500-599.
        </p>

        {/* Definition of Our Academic Term – Academic Quarter Section */}
        <h2 className="text-2xl font-bold mb-4">Definition of Our Academic Term – Academic Quarter</h2>
        <p className="mb-4">
          <strong>Academic Quarter</strong><br />
          An academic quarter means that the course will last and the student will receive at least ten weeks of instruction and learning.
        </p>
        <p className="mb-4">
          <strong>Quarter Credit Hour</strong><br />
          A quarter credit hour is a unit consisting of a minimum of ten hours of instruction during an academic quarter, plus a reasonable period of time outside of instruction which the university requires a student to devote to preparation for learning experiences, such as preparation for instruction, study of course material, or completion of educational projects.
        </p>
        <p className="mb-4">
          Further, it is estimated that the time required to complete one course (3 credit hours) is between 95 to 125 hours. It requires approximately 55 to 60 student study hours to complete one course. It is also estimated that the student will spend 20–25 hours interacting with other students and the Instructor. Preparations for examinations require an additional 20 to 40 hours.
        </p>

        {/* General Education Courses Section */}
        <h2 className="text-2xl font-bold mb-4">General Education Courses</h2>
        <p className="mb-4">
          <strong>ENG 415: Research and Writing (3)</strong><br />
          This course examines and implements the principles of argumentation. An argumentative paper is researched and developed based on the concept of writing as a process. The course focuses on the logical organization of ideas patterned on established structures of argument. It reinforces the importance of the research process and critical evaluation of sources, acknowledging the intellectual property of others through proper documentation.
        </p>
        <p className="mb-4">
          <strong>HUM 300: Introduction to World History (3)</strong><br />
          Explores the history of the world from Paleolithic times to 1500, marking the end of the Middle Ages. Studies the emergence of human beings in Africa and their gradual spread through Eurasia, Australia, and the Americas; examines the parallel development of Chinese, Indian, Middle Eastern, and European civilizations; and investigates their interaction, especially through interregional historical forces such as Hellenism, Christianity, and Buddhism.
        </p>
        <p className="mb-4">
          <strong>PHI 325: Introduction to Logic (3)</strong><br />
          Enables students to develop analytical, inductive, and deductive reasoning through the study of syllogistic, symbolic, and informal logic. It also provides methods for constructing arguments, evaluating statements, and recognizing fallacies in theory as well as in practice.
        </p>
        <p className="mb-4">
          <strong>PHIL 410: Introduction to World Religions (3)</strong><br />
          This course introduces three major religious faiths—Judaism, Christianity, and Islam—their differing views of God, and how those views have shaped the world.
        </p>
        <p className="mb-4">
          <strong>POL 314: Diplomacy in Contemporary International (3)</strong><br />
          Develops a basic understanding of diplomacy in international relations: what diplomacy is, its structure, process, agenda, and the complexities, anomalies, and challenges involved. It follows the historical trajectory of diplomacy and links its relevance to current international issues, events, relations, and nuances. The course is both theoretically grounded and practically useful.
        </p>
        <p className="mb-4">
          <strong>POL 323: Contemporary International Relations (3)</strong><br />
          Examines major phenomena in the contemporary world that affect relations among international actors such as states and international organizations. Topics include globalization, clashes of cultures, democratization, the globalization of capitalism, the proliferation of international organizations and non-state actors, the decline of the nation state, the rise of global issues such as environmental degradation and WMD, and respect for universal values.
        </p>
        <p className="mb-4">
          <strong>PSY 375: Introduction to Psychology (3)</strong><br />
          Introduces psychology as both a human and scientific endeavor, examining concepts and methods in learning, motivation, development, personality, and social behavior.
        </p>
        <p className="mb-4">
          <strong>PSY 377: Social Psychology (3)</strong><br />
          Focuses on major theories in social psychology and recent research in the field. Topics include gender, interpersonal attraction, aggression, and pro-social behavior.
        </p>
        <p className="mb-4">
          <strong>SOC 319: Introduction to Sociology (3)</strong><br />
          Provides a critical survey of contemporary social, political, and economic problems facing American society. Emphasizes issues such as the urban crisis, the military-industrial complex, racism, and income distribution.
        </p>
        <p className="mb-4">
          <strong>SOC 377: Individual and Society (3)</strong><br />
          Presents the various ways in which the individual constructs self-awareness and examines how social institutions such as the family and religion influence individual psychology.
        </p>

        {/* Programs Table */}
        <a name="programs" title="programs"></a>
        <table className="w-full border border-gray-300 text-sm">
          <thead className="bg-gray-700 text-white">
            <tr>
              <th className="border border-gray-300 p-2">College</th>
              <th className="border border-gray-300 p-2">Division</th>
              <th className="border border-gray-300 p-2">Program</th>
              <th className="border border-gray-300 p-2">Notes</th>
            </tr>
          </thead>
          <tbody>
            {/* Hamilton School of Business */}
            <tr>
              <td rowSpan="4" className="border border-gray-300 p-2">
                <a href="/academics/hamilton_business_school" className="text-blue-500 underline"><strong>Hamilton School of Business</strong></a>
              </td>
              <td rowSpan="3" className="border border-gray-300 p-2">EMBA</td>
              <td className="border border-gray-300 p-2">
                <a href="/academics/emba_management_leadership" className="text-blue-500 underline">EMBA in Management and Leadership</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/emba_global_health_care_management" className="text-blue-500 underline">EMBA Global Health Care Management</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/emba_global_public_health_management" className="text-blue-500 underline">EMBA in Global Public Health Management</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">Bachelor's Degree</td>
              <td className="border border-gray-300 p-2">
                <a href="/academics/bs_business_administration_management_leadership" className="text-blue-500 underline">BS in Business Administration, Management &amp; Leadership</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            {/* Spacer row */}
            <tr>
              <td colSpan="4" className="bg-gray-500 p-2">&nbsp;</td>
            </tr>
            {/* College of Christian Studies */}
            <tr>
              <td rowSpan="12" className="border border-gray-300 p-2">
                <a href="/academics/college_christian_studies" className="text-blue-500 underline"><strong>College of Christian Studies</strong></a>
              </td>
              <td rowSpan="8" className="border border-gray-300 p-2">
                <a href="/academics/division_biblical_studies_and_theology" className="text-blue-500 underline">Division of Biblical Studies and Theology</a>
              </td>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_biblical_studies" className="text-blue-500 underline">MA in Biblical Studies</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_ot_studies" className="text-blue-500 underline">MA in OT Studies</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_nt_studies" className="text-blue-500 underline">MA in NT Studies</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_biblical_languages" className="text-blue-500 underline">MA in Biblical Languages</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_theology" className="text-blue-500 underline">MA in Theology</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_systematic_theology" className="text-blue-500 underline">MA in Systematic Theology</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_historical_theology" className="text-blue-500 underline">MA in Historical Theology</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_contemporary_theology" className="text-blue-500 underline">MA in Contemporary Theology</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td rowSpan="3" className="border border-gray-300 p-2">
                <a href="/academics/division_christian_ministry" className="text-blue-500 underline">Division of Christian Ministry</a>
              </td>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_christian_ministry" className="text-blue-500 underline">MA in Christian Ministry</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ma_christian_education" className="text-blue-500 underline">MA in Christian Education</a>
              </td>
              <td className="border border-gray-300 p-2">coming this summer</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">MA in Church Leadership and Administration</td>
              <td className="border border-gray-300 p-2">coming in the fall</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/college_guidance" className="text-blue-500 underline">Division of Christian Counseling and Psychology</a>
              </td>
              <td className="border border-gray-300 p-2">
                <a href="/academics/ms_guidance_counseling" className="text-blue-500 underline">MA in Christian Counseling and Psychology</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td colSpan="4" className="bg-gray-500 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td className="border border-gray-300 p-2">
                <a href="/academics/college_guidance_and_counseling_psychology" className="text-blue-500 underline"><strong>College Of Guidance and Counseling Psychology</strong></a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
              <td className="border border-gray-300 p-2">
                <a href="/academics/med_in_administration_and_supervision" className="text-blue-500 underline">M.Ed in Administration &amp; Supervision</a>
              </td>
              <td className="border border-gray-300 p-2">&nbsp;</td>
            </tr>
            <tr>
              <td colSpan="4" className="bg-gray-500 p-2">&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EducationalRequirements;